module.exports = __webpack_public_path__ + "img/down-arrow.49ffb93c.svg";